import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  API_RESP_STATUS,
  IS_DIALOG_ACCOUNT_CATEGORY_TYPE,
  TRANSACTION_TYPE,
} from "../../Constant/constant";
import AllStateContext from "../../context/allstateContext";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {
  convertToDateTimeFormat,
  currentDate,
  currentTime,
  formatDate,
  formateTimeFromGivenDate,
} from "../../Common/Common";
import { createTransaction, updateTransaction } from "../Apis/apis";

const AddDailog = ({ fetchData }) => {
  const [result, setResult] = useState(0);
  const [input, setInput] = useState("");
  const [amountNotes, setAmountNotes] = useState({ amount: "", notes: "" });
  const {
    transactionType,
    setTransactionType,
    selectedAccount,
    setSelectedAccount,
    selectedCategory,
    setSelectedCategory,
    setOpenDateDialog,
    setIsAccountOrCategoryDialog,
    open,
    setOpen,
    setOpenAccount,
    selectedDate,
    setSelectedDate,
    setOpenTimeDialog,
    selectedTime,
    setSelectedTime,
    recordItem,
  } = useContext(AllStateContext);
  const handleSave = async () => {
    if (!transactionType) {
      alert("Select Transaction type first ...!");
    } else if (!selectedAccount?.accountId) {
      alert("Select Account first ...!");
    } else if (!selectedCategory?.categoryId) {
      alert("Select Category first ...!");
    } else if (!amountNotes?.amount && amountNotes?.amount != null) {
      alert("Amount must be required...!");
    } else {
      try {
        let response;
        if (!recordItem) {
          const body = {
            accountId: selectedAccount.accountId,
            amount: amountNotes.amount,
            type: transactionType,
            categoryId: selectedCategory?.categoryId,
            notes: amountNotes?.notes,
            date: convertToDateTimeFormat(selectedDate, selectedTime),
          };

          response = await createTransaction(body);
        } else {
          const body = {
            accountId: selectedAccount.accountId,
            amount: amountNotes.amount,
            type: transactionType,
            categoryId: selectedCategory?.categoryId,
            notes: amountNotes?.notes,
            date: convertToDateTimeFormat(selectedDate, selectedTime),
          };

          response = await updateTransaction(
            { transactionId: recordItem.transactionId },
            body
          );
        }
        if (response.data.status == API_RESP_STATUS.success) {
          setAmountNotes({ amount: "", notes: "" });
          fetchData();
          setOpen(false);
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const handelAmountNotes = (e) => {
    const { name, value } = e.target;
    setAmountNotes((data) => {
      return { ...data, [name]: value };
    });
  };
  useEffect(() => {
    setSelectedDate(currentDate());
    setSelectedTime(currentTime());
  }, []);

  useMemo(() => {
    if (recordItem) {
      setTransactionType(recordItem.type);

      setSelectedAccount({
        accountId: recordItem.accountId,
        icon: recordItem.accountDetails.iconDetail.icon,
        name: recordItem.accountDetails.name,
      });
      setAmountNotes({
        amount: recordItem.amount,
        notes: recordItem.notes,
      });
      setSelectedCategory({
        categoryId: recordItem.categoryId,
        icon: recordItem.categoryDetails.iconDetail.icon,
        name: recordItem.categoryDetails.name,
      });
      // formateTimeFromGivenDate
      setSelectedTime(formateTimeFromGivenDate(recordItem.date));
      setSelectedDate(formatDate(recordItem.date));
    } else {
      setTransactionType(TRANSACTION_TYPE.EXPENSE);
      setSelectedAccount({
        icon: require("../../Common/Icon/icon_select.png"),
        name: "Account",
      });
      setAmountNotes({
        amount: "",
        notes: "",
      });
      setSelectedCategory({
        icon: require("../../Common/Icon/icon_select.png"),
        name: "Category",
      });
    }
  }, [recordItem]);
  useMemo(() => {
    if (!recordItem) {
      if (transactionType === TRANSACTION_TYPE.TRANSFER) {
        setSelectedAccount("");
        setSelectedCategory("");
      } else {
        setSelectedCategory("");
      }
    }
  }, [transactionType]);

  const dialogSelectAccount = (type) => {
    setIsAccountOrCategoryDialog(type);
    setOpenAccount(true);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">
          {"Create Transaction"}
        </DialogTitle>
        <DialogContent>
          {/* <AccountDialog /> */}
          <div className="d-flex justify-content-center gap-2 mb-4">
            <button
              type="button"
              className={`btn ${transactionType === TRANSACTION_TYPE.INCOME ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setTransactionType(TRANSACTION_TYPE.INCOME)}
              style={{ flex: 1, padding: "8px 12px", fontSize: "0.85rem" }}
            >
              INCOME
            </button>
            <button
              type="button"
              className={`btn ${transactionType === TRANSACTION_TYPE.EXPENSE ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setTransactionType(TRANSACTION_TYPE.EXPENSE)}
              style={{ flex: 1, padding: "8px 12px", fontSize: "0.85rem" }}
            >
              EXPENSE
            </button>
            <button
              type="button"
              className={`btn ${transactionType === TRANSACTION_TYPE.TRANSFER ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setTransactionType(TRANSACTION_TYPE.TRANSFER)}
              style={{ flex: 1, padding: "8px 12px", fontSize: "0.85rem" }}
            >
              TRANSFER
            </button>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-6">
              <div style={{ fontSize: "0.82rem", color: "var(--text-secondary)", marginBottom: "6px", fontWeight: "600", textTransform: "uppercase" }}>
                {transactionType === TRANSACTION_TYPE.TRANSFER ? "From Account" : "Source Account"}
              </div>
              <button
                onClick={() =>
                  dialogSelectAccount(IS_DIALOG_ACCOUNT_CATEGORY_TYPE.ACCOUNT)
                }
                type="button"
                className="w-100 d-flex align-items-center justify-content-between"
                style={{
                  background: "rgba(255, 255, 255, 0.02)",
                  border: "1.5px solid var(--border-color)",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  color: "var(--text-primary)",
                  textAlign: "left",
                  transition: "all var(--transition-fast)",
                  height: "48px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--primary)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-color)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
                }}
              >
                <div className="d-flex align-items-center gap-3 text-truncate">
                  <img
                    style={{ width: "24px", height: "24px", borderRadius: "6px" }}
                    src={
                      selectedAccount?.icon || selectedAccount
                        ? selectedAccount.icon
                        : require("../../Common/Icon/icon_select.png")
                    }
                    alt="account-icon"
                  />
                  <span className="text-truncate" style={{ fontWeight: "600", fontSize: "0.95rem" }}>
                    {selectedAccount?.name || "Select Account"}
                  </span>
                </div>
                <span style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>▼</span>
              </button>
            </div>

            <div className="col-6">
              <div style={{ fontSize: "0.82rem", color: "var(--text-secondary)", marginBottom: "6px", fontWeight: "600", textTransform: "uppercase" }}>
                {transactionType === TRANSACTION_TYPE.TRANSFER ? "To Account" : "Category"}
              </div>
              <button
                onClick={() =>
                  dialogSelectAccount(IS_DIALOG_ACCOUNT_CATEGORY_TYPE.CATEGORY)
                }
                type="button"
                className="w-100 d-flex align-items-center justify-content-between"
                style={{
                  background: "rgba(255, 255, 255, 0.02)",
                  border: "1.5px solid var(--border-color)",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  color: "var(--text-primary)",
                  textAlign: "left",
                  transition: "all var(--transition-fast)",
                  height: "48px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--primary)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-color)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
                }}
              >
                <div className="d-flex align-items-center gap-3 text-truncate">
                  <img
                    style={{ width: "24px", height: "24px", borderRadius: "6px" }}
                    src={
                      selectedCategory?.icon || selectedCategory
                        ? selectedCategory.icon
                        : require("../../Common/Icon/icon_select.png")
                    }
                    alt="category-icon"
                  />
                  <span className="text-truncate" style={{ fontWeight: "600", fontSize: "0.95rem" }}>
                    {transactionType === TRANSACTION_TYPE.TRANSFER
                      ? selectedCategory?.name || "Select Account"
                      : selectedCategory?.name || "Select Category"}
                  </span>
                </div>
                <span style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>▼</span>
              </button>
            </div>
          </div>

          <div className="form-floating mb-3">
            <input
              name="amount"
              type="number"
              onChange={handelAmountNotes}
              value={amountNotes.amount}
              className="form-control"
              placeholder=" "
              id="amountInput"
              required
            />
            <label htmlFor="amountInput">Amount</label>
          </div>

          <div className="form-floating mb-3">
            <textarea
              name="notes"
              onChange={handelAmountNotes}
              value={amountNotes.notes}
              className="form-control"
              placeholder=" "
              id="notesInput"
              style={{ height: "80px" }}
            />
            <label htmlFor="notesInput">Notes</label>
          </div>

          <div className="row g-2 mb-1">
            <div className="col-6">
              <button
                onClick={() => setOpenDateDialog(true)}
                type="button"
                className="w-100 d-flex align-items-center justify-content-center gap-2"
                style={{
                  background: "rgba(255, 255, 255, 0.02)",
                  border: "1.5px solid var(--border-color)",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  color: "var(--text-primary)",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  transition: "all var(--transition-fast)",
                  height: "44px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--primary)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-color)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
                }}
              >
                <span>📅</span> {selectedDate}
              </button>
            </div>

            <div className="col-6">
              <button
                onClick={() => setOpenTimeDialog(true)}
                type="button"
                className="w-100 d-flex align-items-center justify-content-center gap-2"
                style={{
                  background: "rgba(255, 255, 255, 0.02)",
                  border: "1.5px solid var(--border-color)",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  color: "var(--text-primary)",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  transition: "all var(--transition-fast)",
                  height: "44px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--primary)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-color)";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.02)";
                }}
              >
                <span>⏰</span> {selectedTime}
              </button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setOpen(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save changes
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddDailog;
